import { ValueOf } from "../type";

export const GovAddressKey = {
  PaginateGovAddress: "PAGINATE_GOV_ADDRESS",
} as const;

export type GovAddressKeyType = ValueOf<typeof GovAddressKey>;
